import { render } from "./FloorAreaControl.vue?vue&type=template&id=4e3ac715&ts=true"
import script from "./FloorAreaControl.vue?vue&type=script&lang=ts"
export * from "./FloorAreaControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__